import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import apiHelper from '../../apiHelper';

export default function EditOrganisation() {
    const history = useHistory();
    const [validationError, setValidationError] = useState([]);
    const [successMessage, setSuccessMessage] = useState('');

    const handleSave = async () => {

        if(!formData.organisation_name){
            let form_errors = { "organisation_name" : "This field is required!"};
            setFormErrors(form_errors);
            return false; 
        }
              
        const response = await apiHelper('entities/organisation-update/','POST', formData); 
         
        if(response){
            if(response.ok){
                setSuccessMessage('Organisation updated successfully.');
                setValidationError([]);
            }
            else if(response.status == 400){ //for validation error
                const response_errors = await response.json();
                let errors = [];
                for(let i in response_errors){
                    errors.push(`${i}: ${response_errors[i][0]}`);
                }
                setValidationError(errors);
                setSuccessMessage('');
            }
        }

    };

    const handleDiscard = () => {
        history.goBack();
    };

    const [activeTab, setActiveTab] = useState("Edit Organisation Info");

    const breadcrumbs = [
        "Organisations",
        "Company",
        "Organisation Info",
        activeTab
    ];

    const [formData, setFormData] = useState({
        organisation_name: '',
        notes: '',
         
    });

    const [errors, setFormErrors] = useState({
        department_name: '',
        short_name: ''   
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    useEffect(() => {

        async function fetchOrganisation() {
          const response = await apiHelper('entities/organisation/');
          if (response && response.ok) {
            const result = await response.json(); 
            setFormData(result);
          }

        }
        fetchOrganisation();
 
  }, []); // Empty dependency array ensures the effect runs only once


    return (
        <>
            <div className="company-body main-company-body-inner">
                <div className="breadcrumb">
                    {breadcrumbs.map((crumb, index) => {
                        const isLast = index === breadcrumbs.length - 1;

                        return (
                            <span
                                key={index}
                                className={`breadcrumb-item ${crumb === "Organisation Info" ? "clickable" : ""}`}
                                onClick={() => {
                                    if (crumb === "Organisation Info") {
                                        history.push("/company");
                                    }
                                }}
                                style={{ cursor: crumb === "Organisation Info" ? "pointer" : "default" }}
                            >
                                {crumb}
                                {!isLast ? "  " : ""}
                            </span>
                        );
                    })}
                </div>

                <div className='edit-organisation-info'>
                    <div className='edit-organisation-left'>
                        <h1>Edit Organisation Info</h1>
                    </div>
                    <div className='discard-save-organisation-right d-flex align-items-center gap-2'>
                        <button className="dark-button" type='button' onClick={handleDiscard}>Discard</button>
                        <button className="dark-border" type='button' onClick={handleSave}>Save</button>
                    </div>
                </div>

                <div className="info-section">
                    <div className="info-card">
                        <div className="info-header">
                            <h4 className="info-title">Organisation Info</h4>
                        </div> 
                        {successMessage && <div style={{ color: 'green', paddingLeft: '20px' }} className="success-message">{successMessage}</div>} 
                        <ul style={{ color: 'red' }}>
                          {validationError && validationError.map((error, index) => (
                            <li key={index}>{error}</li>
                          ))}
                        </ul>
                        <div className="info-content">

                            <div className="info-inner newinfoinner-type-cls">
                                <label htmlFor="organisationname" className="form-label">
                                    Organisation Name <span className='error-color'>*</span>
                                </label>
                                <input type="text" name="organisation_name" value={formData.organisation_name} onChange={handleChange} className="form-control common-input-all" id="organisationname" placeholder="organisation name" />
                                {errors.organisation_name && <p style={{ color: 'red' }}>{errors.organisation_name}</p>}
                            </div>
                        </div>
                    </div>

                    <div className="info-card">
                        <div className="info-header">
                            <h4 className="info-title">Additional Info</h4>
                        </div>
                        <div className="info-content">

                            <div className="info-inner common-textarea">
                                <label htmlFor="exampleFormControlTextarea1" className="form-label">Note</label>
                                <textarea className="form-control w-100 common-textarea-all" name="notes" value={formData.notes} onChange={handleChange} id="exampleFormControlTextarea1" rows="3"></textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
